var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7794 2.45139C11.3812 1.84954 12.357 1.84954 12.9589 2.45139L14.0486 3.54114C14.6505 4.14299 14.6505 5.11879 14.0486 5.72064L13.0824 6.68685C13.0065 6.64929 12.9268 6.60868 12.844 6.56511C12.2871 6.2719 11.6261 5.86038 11.1329 5.36713C10.6396 4.87388 10.2281 4.21297 9.93491 3.65602C9.89134 3.57326 9.85072 3.49345 9.81316 3.41759L10.7794 2.45139ZM10.4258 6.07424C11.0095 6.65791 11.7518 7.11729 12.3396 7.42961L8.54003 11.2292C8.30424 11.465 7.99833 11.618 7.66823 11.6651L5.37975 11.992C4.8712 12.0647 4.4353 11.6288 4.50795 11.1202L4.83488 8.83177C4.88203 8.50167 5.03499 8.19576 5.27078 7.95997L9.0704 4.16035C9.38271 4.74823 9.8421 5.49055 10.4258 6.07424ZM3 13C2.72386 13 2.5 13.2239 2.5 13.5C2.5 13.7761 2.72386 14 3 14H14C14.2761 14 14.5 13.7761 14.5 13.5C14.5 13.2239 14.2761 13 14 13H3Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilLine);
export default __webpack_public_path__ + "static/media/edit-pencil-line.46e16691.svg";
export { ForwardRef as ReactComponent };